import {
    ChangeDetectorRef,
    ContentChild,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Renderer2,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {DynamicFieldComponent} from '../../../dynamic-field/dynamic-field-component';
import {MatLegacyFormField as MatFormField, MatLegacyFormFieldControl as MatFormFieldControl} from '@angular/material/legacy-form-field';
import {FieldConfigWrapper} from '../../../dynamic-field/field-config-wrapper';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {FieldAffix} from '../../../affix/field-affix';


@UntilDestroy()
export class BaseFieldComponent<T> implements DynamicFieldComponent, OnInit, OnChanges, OnDestroy {

    // @HostBinding('class')
    public cssClass = '';
    @ViewChild(MatFormField, {static: false})
    public matFormField: MatFormField;
    @ContentChild(MatFormFieldControl, {static: false})
    public placeholderControl: MatFormFieldControl<any>;
    @Input()
    public fieldWrapper: FieldConfigWrapper<T>;
    @Input()
    public formGroup: UntypedFormGroup;
    @Input()
    public maxCollapsedWidth = 500;
    public staticCssClass = '';
    public control: AbstractControl;
    public errors = null;
    public readonly = false;
    private baseCssClass = 'mydocma-base-field'

    constructor(
        public dynamicFormService: DynamicFormService,
        public changeDetectorRef: ChangeDetectorRef,
        public eventDispatcher: EventDispatcherService,
        private element: ElementRef,
        protected renderer: Renderer2
    ) {
    }


    /**
     * Lifecycle hook that is called after data-bound properties of a directive are initialized.
     */
    public ngOnInit() {
        this.control = this.formGroup.get((this.fieldWrapper.config as any).name);
        this.control.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(value => {
                this.notifyValueChange(value)
            });

        this.control.statusChanges
            .pipe(untilDestroyed(this))
            .subscribe(status => {
                this.eventDispatcher.notifyFieldStatusChanged({config: this.fieldWrapper.config, status});
            });

        this.fieldWrapper.onUpdated
            .pipe(untilDestroyed(this))
            .subscribe((value) => {
                this.onFieldWrapperUpdated();
            });
        this.setCssClass((this.fieldWrapper?.config as any).class);

    }

    /**
     * A lifecycle hook that is called when any data-bound property of a directive changes.
     *
     * @param changes - changes
     */
    public ngOnChanges(changes: SimpleChanges) {
        if (changes.fieldWrapper) {
            this.setCssClass(changes.fieldWrapper.currentValue.config?.class);
            if (changes.fieldWrapper.currentValue.config?.readonly) {
                this.readonly = true;
            }
        }
    }

    public onSuffixClick() {
        const suffix = ((this.fieldWrapper.config as any)?.suffix as FieldAffix);
        if (suffix?.click) {
            suffix.click();
        }

        this.eventDispatcher.notifyControlSuffixClick(this.fieldWrapper.config);
    }

    public onPrefixClick() {
        const prefix = ((this.fieldWrapper.config as any)?.prefix as FieldAffix);
        if (prefix?.click) {
            prefix.click();
        }
        this.eventDispatcher.notifyControlPrefixClick(this.fieldWrapper.config);
    }

    public onControlClick() {
        this.eventDispatcher.notifyControlClick(this.fieldWrapper.config);
    }

    public onFieldWrapperUpdated() {
        // this.control.updateValueAndValidity();
        const configClass = (this.fieldWrapper.config as any).class;
        this.setCssClass(configClass);
    }

    public onSubmit() {
        this.eventDispatcher.notifySubmit();
    }

    /**
     * A lifecycle hook that is called when a directive, pipe, or service is destroyed.
     */
    public ngOnDestroy(): void {
    }

    protected notifyValueChange(value: any) {
        this.eventDispatcher.notifyFieldValueChanged({config: this.fieldWrapper.config, value});
    }

    private setCssClass(dynamicCssClass) {
        this.cssClass = `${this.baseCssClass} ${this.staticCssClass}`;
        if (dynamicCssClass) {
            this.cssClass = `${this.baseCssClass} ${this.staticCssClass} ${dynamicCssClass}`;
        }

        if (!this.element.nativeElement) return;
        this.element.nativeElement.className = this.cssClass;

    }
}
